import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import Sidebar from "@/components/Sidebar";
import { useAuth } from "@/context/AuthContext";

export default function Layout() {
  const { user, loading } = useAuth();
  const [open, setOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white">
        <div className="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="flex min-h-screen bg-slate-100">
      {open && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setOpen(false)} data-testid="sidebar-overlay" />}
      <Sidebar mobileOpen={open} onClose={() => setOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="no-print lg:hidden sticky top-0 z-30 bg-[#0b1220] text-white flex items-center gap-3 px-4 py-3">
          <button onClick={() => setOpen(true)} data-testid="sidebar-toggle" className="p-1"><Menu className="w-6 h-6" /></button>
          <ShieldCheck className="w-6 h-6 text-amber-400" />
          <span className="font-bold">HSE Report</span>
        </header>
        <main className="flex-1 min-w-0 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
